import {Component, OnDestroy, OnInit} from '@angular/core';
import {Report} from '../report/report.model';
import {ReportService} from '../report/report.service';
import {RequestParams} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import 'rxjs/add/operator/map';

@Component({
  templateUrl: './assignment-report-form.component.html'
})
export class AssignmentReportFormComponent implements OnInit, OnDestroy {

  public report: Report;
  public reports: Report[] = [];

  constructor(
    private router: UIRouter,
    private reportService: ReportService
  ) {}

  public ngOnInit(): void {
    const requestParams = new RequestParams();
    requestParams.pagination.limit = 0;

    this.reportService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
    this.reportService.getAll(requestParams).map((linkedReports: Report[]) => {
      return linkedReports.map((report: Report) => report.reportId);
    }).subscribe((linkedReports: string[]) => {
      this.reportService.clearRoutePrefix();
      this.reportService.getAll(requestParams).subscribe((reports: Report[]) => {
        this.reports = reports.filter((report: Report) => {
          return (linkedReports.indexOf(<string>report.id) === -1);
        });
      });
    });
  }

  public ngOnDestroy(): void {
    this.reportService.clearRoutePrefix();
  }

  public save() {
    this.reportService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
    this.reportService.add(this.report).subscribe((response) => {
      const currentStateParts = this.router.stateService.$current.name.split('.');
      currentStateParts.pop();
      const parentState = currentStateParts.join('.');
      this.reportService.clearRoutePrefix();
      this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment-report-form.component.ts